/* eslint-disable */
import { T, useTheme } from "../tokens";
import { canvasHeightForViewport } from "./layoutTokens";

const WIDTH = {
  desktop: "100%",
  tablet: "768px",
  mobile: "375px",
};

/** Wraps entire app chrome for wizard/prototype viewport toggles. */
export default function ViewportFrame({
  viewport = "desktop",
  dark = true,
  children,
  fullHeight = false,
  minCanvasHeight,
  style = {},
}) {
  const th = useTheme(dark);
  const isMobile = viewport === "mobile";
  const isTablet = viewport === "tablet";
  const framed = isMobile || isTablet;
  const canvasMinHeight = minCanvasHeight ?? canvasHeightForViewport(viewport);

  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: framed ? "center" : "stretch",
        justifyContent: framed ? "flex-start" : "stretch",
        overflow: "hidden",
        padding: framed ? (isMobile ? "16px 12px" : "20px 16px") : 0,
        background: framed ? th.muted : "transparent",
        ...style,
      }}
    >
      <div
        style={{
          width: WIDTH[viewport] || "100%",
          maxWidth: "100%",
          flexShrink: 0,
          minHeight: fullHeight && framed ? "min(100%, 720px)" : canvasMinHeight,
          height: fullHeight && !framed ? "100%" : canvasMinHeight,
          display: "flex",
          flexDirection: "column",
          background: th.bg,
          borderRadius: framed ? (isMobile ? 20 : 12) : 0,
          border: framed ? `1px solid ${th.border}` : "none",
          boxShadow: isMobile
            ? "0 0 0 8px rgba(0,0,0,0.25), 0 12px 40px rgba(0,0,0,0.15)"
            : isTablet
              ? "0 8px 32px rgba(0,0,0,0.12)"
              : "none",
          overflow: "hidden",
          transition: `width ${T.slow} ${T.ease}`,
        }}
      >
        <div
          style={{
            flex: 1,
            minHeight: 0,
            minWidth: 0,
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
